import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function TimeDepositRow() {
   return (
      <InputRangeRow
         titleProp={"Time Deposit"}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={10}
         propertyNameProp={"timeDeposit"}
         errorDialogueProp={"0-10 only"}
         floatProp={false}
      />
   );
}
